import { createContext } from "react";

export const GrantsContext = createContext({});
export const GrantDetailsContext = createContext({});
